import React from 'react';
require(`../assets/${process.env.PAGE}/css/custom-spinner.css`);

    function CustomSpinner(props) {
        return (
            <div className="custom-spinner-backdrop">
                <div className="custom-spinner-containter">
                    <div className="custom-spinner-content text-center">
                        <div className="square"> 
                            <div className="arrow-up"> 
                            </div>
                        </div>
                        <p>{props.message}</p>
                    </div>
                </div>
            </div>
            );
    };
export default CustomSpinner;


/** WEBPACK FOOTER **
 ** ./src/components/CustomSpinner.js
 **/